
const app = {
  // App
  app: {
    title: "Titan Predictions",
    language: "Language"
  }
};

export default app;
